module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "fut_toc"
  }), _vm._v(" "), _c('p', {
    staticClass: "fut_toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/dedication#ded"
    }
  }, [_vm._v("Begin Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "fut_toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "fut_toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abouttheauthor#ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Poet")])]), _vm._v(" "), _c('p', {
    staticClass: "fut_toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#cpy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('p', {
    staticClass: "fut_toc1"
  }), _vm._v(" "), _c('p', {
    staticClass: "fut_toc"
  }, [_c('b', [_vm._v("Thank you for buying this")])]), _vm._v(" "), _c('p', {
    staticClass: "fut_toc"
  }, [_c('b', [_vm._v("St. Martin’s Press ebook.")])]), _vm._v(" "), _c('p', {
    staticClass: "fut_toc"
  }), _vm._v(" "), _c('p', {
    staticClass: "fut_toc"
  }, [_vm._v("To receive special offers, bonus content,")]), _vm._v(" "), _c('p', {
    staticClass: "fut_toc"
  }, [_vm._v("and info on new releases and other great reads,")]), _vm._v(" "), _c('p', {
    staticClass: "fut_toc"
  }, [_vm._v("sign up for our newsletters.")]), _vm._v(" "), _c('p', {
    staticClass: "fut_toc"
  }), _vm._v(" "), _c('p', {
    staticClass: "fut_tit"
  }, [_c('a', {
    attrs: {
      "href": "http://us.macmillan.com/newslettersignup?utm_source=ebook&utm_medium=adcard&utm_term=ebookreaders&utm_content=alfa_newslettersignup_macdotcom&utm_campaign=9781250233585",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "epub",
    attrs: {
      "alt": "image",
      "height": "67",
      "src": "images/NewsletterSignup.jpg",
      "width": "112"
    }
  }), _c('img', {
    staticClass: "sign-up",
    attrs: {
      "alt": "image",
      "src": "images/NewsletterSignup.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "fut_toc"
  }, [_vm._v("Or visit us online at")]), _vm._v(" "), _c('p', {
    staticClass: "fut_toc"
  }, [_c('a', {
    attrs: {
      "href": "http://us.macmillan.com/newslettersignup?utm_source=ebook&utm_medium=adcard&utm_term=ebookreaders&utm_content=alfa_newslettersignup_macdotcom&utm_campaign=9781250233585",
      "target": "_blank"
    }
  }, [_vm._v("us.macmillan.com/newslettersignup")])]), _vm._v(" "), _c('p', {
    staticClass: "fut_toc"
  }), _vm._v(" "), _c('p', {
    staticClass: "fut_toc"
  }, [_vm._v("For email updates on the author, click "), _c('a', {
    attrs: {
      "href": "http://us.macmillan.com/authoralerts?authorName=dbtmp1105055&authorRefId=200069397&utm_source=ebook&utm_medium=adcard&utm_term=ebookreaders&utm_content=alfa_authoralertsignup_macdotcom&utm_campaign=9781250233585",
      "target": "_blank"
    }
  }, [_vm._v("here")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56cecf22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/mini_toc.vue
// module id = 60
// module chunks = 0